import $i18n from '@/lang/index';

export const headerList = [
  {
    id: 1,
    label: $i18n.t('home.onDutyDate'),
    prop: 'workDate',
    cloWidth: 150,
    center: 'center'
  },
  {
    id: 2,
    label: $i18n.t('home.position'),
    prop: 'positionName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 3,
    label: $i18n.t('collectionCenter.transferCenter'),
    prop: 'department',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 4,
    label: $i18n.t('home.onDutyCount'),
    prop: 'staffCount',
    cloWidth: 160,
    center: 'center'
  },
  // 登记时间
  {
    id: 5,
    label: $i18n.t('collectionCenter.RegistrationT'),
    prop: 'registrationTime',
    cloWidth: 150,
    center: 'center'
  },
  {
    id: 6,
    label: $i18n.t('collectionCenter.registrar'),
    prop: 'registrationUserName',
    cloWidth: 160,
    center: 'center'
  }
];
